import React from 'react';
import { Routes, Route, Outlet } from "react-router-dom";
import Sidebar from "../../layouts/sidebar/Sidebar"
import './Dashboard.css';
import Header from "../../layouts/header/Header"



function Dashboard() {
 
  return (
    <div id="main">

          <div className="dashboard-container" id="dashboard" >


            <Sidebar />


            <div className='main-content-div' >
            <Header />
              {/* <Header /> */}
              {/* Common Components */}
              <Outlet />
              {/* Common Components */}

            </div>
            {/* <div className="mobileSideBar_footer" id="footer">
              <footer className='footerMob' id="footerVal"><img src={poweredByP360} alt="" /></footer>
            </div> */}
          </div>
       </div>
          
  );
}

export default Dashboard;
